import React, {ReactNode} from "react";
import {Colors} from "../Types";

const colors = Object.freeze<Record<'white' | 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary' | 'primaryWoman'| 'accentWoman', string>>({
  white: 'text-white',
  primary: 'text-primary',
  secondary: 'text-secondary',
  tertiary: 'text-tertiary',
  quaternary: 'text-quaternary',
  quinary: 'text-quinary',
  primaryWoman:'text-primaryWoman',
  accentWoman:'text-accentWoman'
});

const Headline: React.FC<Props> = (
  {
    children,
    size = 'base',
    color = 'white',
    textAlign = 'text-left'
  }
) => {
  switch (size) {
    case "h1":
      return <h1
        className={`font-serif font-medium text-5xl ${colors[color]} ${textAlign}`}
      >
        {children}
      </h1>;

    case "h2":
      return <h2
        className={`font-serif font-medium text-4xl ${colors[color]} ${textAlign}`}
      >
        {children}
      </h2>;

    case "h3":
      return <h3
        className={`font-serif font-medium text-3xl ${colors[color]} ${textAlign}`}
      >
        {children}
      </h3>;

    case "h4":
      return <h4
        className={`font-serif font-medium text-2xl ${colors[color]} ${textAlign}`}
      >
        {children}
      </h4>;

    default:
      return <h1
        className={`font-serif font-medium text-5xl ${colors[color]} ${textAlign}`}
      >
        {children}
      </h1>;
  }
};

export default Headline;

interface Props {
  children?: ReactNode;
  size?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
  color?: Colors;
  textAlign?: 'text-left' | 'text-center' | 'text-right' | 'text-center 2xl:text-left';   // the last one: centred on mobile, left on desktop
};